export default "__VITE_ASSET__DTvFJPaj__"